import { AnyObject } from "../../interfaces/anyObject";

export const cleanupObject = <T = AnyObject>(object: AnyObject): T => {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === "object") {
      cleanupObject(v);
    }

    if (
      (v && typeof v === "object" && !Object.keys(v).length)
      || v === null || v === undefined || v === "" || Number.isNaN(v)
    ) {
      if (Array.isArray(object)) {
        object.splice(Number(k), 1);
      } else {
        // eslint-disable-next-line no-param-reassign
        delete object[k];
      }
    }
  });

  return object as T;
};

export const trimObjectValues = (values: AnyObject): AnyObject => {
  const tmpValues = { ...values };
  Object.keys(tmpValues).forEach((k) => {
    tmpValues[k] = typeof tmpValues[k] === "string" ? tmpValues[k].trim() : tmpValues[k];
  });

  return tmpValues;
};
